import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
	standalone: true,
	selector: 'input-tabs',
	templateUrl: './input-tabs.component.html',
	imports: [ CommonModule, FormsModule ]
})
export class InputTabsComponent implements OnInit {
	
	@Input() isRequired: any | undefined;
	@Input() name: any | undefined;
	@Input() tabs: any;
	@Input() model: any;
	@Output() modelChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() id: any | undefined;
	@Input() label: any | undefined;
	@Input() isDisabled: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	onSelectionChange(event: Event): void {
		const inputElement = event.target as HTMLInputElement;
		this.modelChange.emit(inputElement.value);
	}
	
	ngOnInit() {
		
	}
	
}